import { connect } from 'react-redux';
import Siblings from './siblings';

const mapStateToProps = state => ({
  data: state.siblings.data,
  failed: state.siblings.failed,
  scale: state.scale,
  stayFitToWidth: state.stayFitToWidth,
  clientWidth: state.clientSize.width,
  defaultPageWidth: state.defaultPageSize.width,
  sidePanelOpen: state.sidebar.isOpen,
  idType: state.idType,
  siblingsFetcherDisabled: !state.viewConfig.fetchers.includes('fetchSiblings'),
  adobeContentType: state.metadata.adobeContentType,
});

export default connect(mapStateToProps)(Siblings);
